/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState } from "react";
import { cn } from "tailwind-variants";
import { isTouchDevice } from "common/utils/browser";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
// eslint-disable-next-line import/no-cycle
import ArtworkImage from "./ArtworkImage.vue";
import BackgroundToggle from "./common/BackgroundToggle.vue";
import MobileImageModal from "./common/MobileImageModal.vue";
import { useDtfStore } from "./store";
import { getArtworkSrc } from "./utils";
import "./ArtworkFullScreen.scss";

export default function ArtworkFullScreen({
  artwork = {},
  activeConfigSection,
  withMade = false,
  shouldDisableSlider = false,
  sliderBeforeImage = ""
}: any) {
  const store = useDtfStore();
  const [showComparisonModal, setShowComparisonModal] = useState(false);

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function enabledButton() {
    return isStandardArtwork() && !artwork?.isLoading && artwork?.url;
  }

  function showFullScreenButton() {
    return (enabledButton() || withMade) && isTouchDevice();
  }

  function showDesktopModal() {
    return isStandardArtwork() && showComparisonModal && artwork && !isTouchDevice();
  }

  function showMobileModal() {
    return showComparisonModal && artwork && isTouchDevice();
  }

  function wrapperClass() {
    return `js-modal-magnify-wrapper-${artwork?.id || "x"}`;
  }

  function artworkSrc() {
    return getArtworkSrc(artwork);
  }

  function toggleComparisonModal() {
    setShowComparisonModal(!showComparisonModal);
  }

  return (
    <>
      {showFullScreenButton() ? (
        <button
          className={cn("artwork-full-screen__button scope-ef81b391", {
            "artwork-full-screen__button--with-made": withMade
          })}
          disabled={!enabledButton()}
          type="button"
          onClick={toggleComparisonModal}
          data-testid="artwork-full-screen-button"
        >
          <UseSvg
            className="artwork-full-screen__button-icon scope-ef81b391"
            icon="full-screen"
            data-testid="artwork-full-screen-button-icon"
          />

          <span className="scope-ef81b391">Full Screen</span>
        </button>
      ) : null}
      {showDesktopModal() ? (
        <CommonModal
          className="scope-ef81b391"
          onClose={toggleComparisonModal}
          data-testid="common-modal"
        >
          <BackgroundToggle
            className="scope-ef81b391"
            // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
            modelValue={store.backgroundType}
            onUpdateModelValue={(e: any) => {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              store.setBackgroundType(e);
            }}
            data-testid="background-toggle"
          />

          <div className="artwork-full-screen__artwork-image scope-ef81b391">
            <ArtworkImage
              className="scope-ef81b391"
              key={artwork.id}
              artwork={artwork}
              fitToContainer={true}
              activeConfigSection={activeConfigSection}
              data-testid="artwork-image"
            />
          </div>
        </CommonModal>
      ) : null}
      {showMobileModal() ? (
        <MobileImageModal
          className="scope-ef81b391"
          src={shouldDisableSlider ? sliderBeforeImage : artworkSrc()}
          wrapperClass={wrapperClass()}
          onClose={toggleComparisonModal}
          data-testid="mobile-image-modal"
        />
      ) : null}
    </>
  );
}
